import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function BaseRegister() {
  const [step, setStep] = useState(1)
  const [form, setForm] = useState({
    name: '', type: '机构基地', city: '', address: '', contact: '', phone: '', password: '',
    capacity: '', facilities: '', description: '', recommendCode: ''
  })
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [result, setResult] = useState(null)
  const [referrerId, setReferrerId] = useState('')

  // 从URL获取推荐人ID
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const ref = params.get('ref')
    if (ref) {
      setReferrerId(ref)
      fetch(`${API}/partners/lookup?code=${ref}`)
        .then(r => r.json())
        .then(d => {
          if (d.success && d.data) {
            setForm(prev => ({ ...prev, recommendCode: ref }))
          }
        })
        .catch(e => { console.error(e) })
    }
  }, [])

  // 根据推荐码查找推荐人
  const lookupReferrer = async (code) => {
    if (!code || code.length < 4) {
      setReferrerId('')
      return
    }
    try {
      const res = await fetch(`${API}/partners/lookup?code=${code}`)
      const d = await res.json()
      if (d.success && d.data) {
        setReferrerId(d.data.id)
      } else {
        setReferrerId('')
      }
    } catch (e) {
      setReferrerId('')
    }
  }

  const handleRecommendCodeChange = (value) => {
    setForm({ ...form, recommendCode: value })
    lookupReferrer(value)
  }

  const handleSubmit = async () => {
    if (!form.name.trim()) { alert('请输入基地名称'); return }
    if (!form.phone || !/^1\d{10}$/.test(form.phone)) { alert('请输入正确的手机号'); return }
    if (!form.password || form.password.length < 6) { alert('请输入至少6位密码'); return }
    
    setLoading(true)
    try {
      const res = await fetch(`${API}/bases`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, referrer: referrerId })
      })
      const d = await res.json()
      if (d.success) {
        setResult(d.data)
        setSuccess(true)
      } else {
        alert(d.error || '注册失败')
      }
    } catch (e) {
      alert('注册失败')
    }
    setLoading(false)
  }

  if (success && result) {
    return (
      <div style={{ padding: 40, maxWidth: 600, margin: '0 auto' }}>
        <div style={{ background: '#fff', borderRadius: 16, padding: 32, textAlign: 'center', boxShadow: '0 4px 16px rgba(0,0,0,0.1)' }}>
          <div style={{ fontSize: 64, marginBottom: 16 }}>🎉</div>
          <h2 style={{ fontSize: 24, color: '#52c41a', marginBottom: 16 }}>恭喜！申请成功！</h2>
          <p style={{ color: '#666', marginBottom: 24 }}>
            您已获得 <strong style={{ color: '#fa8c16', fontSize: 18 }}>7天免费基地体验期</strong>
          </p>
          
          <div style={{ background: '#fff7e6', border: '1px solid #ffd591', borderRadius: 8, padding: 20, textAlign: 'left', marginBottom: 24 }}>
            <div style={{ fontWeight: 600, marginBottom: 12, color: '#fa8c16' }}>🎁 您已获得（企业版基地7天体验）：</div>
            <div style={{ display: 'grid', gap: 8, fontSize: 14, color: '#666' }}>
              <div>✅ <strong>90%</strong>最高服务分润比例</div>
              <div>✅ 发布活动权限</div>
              <div>✅ 学员管理系统</div>
              <div>✅ 平台流量扶持</div>
              <div>✅ 专业活动策划支持</div>
              <div>✅ 优先推荐展示</div>
            </div>
          </div>
          
          <div style={{ background: '#f6ffed', borderRadius: 8, padding: 20, textAlign: 'left', marginBottom: 24 }}>
            <div style={{ fontWeight: 600, marginBottom: 12 }}>基地信息：</div>
            <div style={{ display: 'grid', gap: 8, fontSize: 14 }}>
              <div>基地名称：<strong>{result.name}</strong></div>
              <div>基地ID：{result.id}</div>
              <div>等级：<strong style={{ color: '#fa8c16' }}>{result.level || '企业版基地'}</strong></div>
              <div>分润比例：<strong style={{ color: '#52c41a' }}>{result.commission_rate_display || (result.commission_rate * 100) + '%'}</strong></div>
              <div>体验到期：{result.days_left || 7} 天后</div>
            </div>
          </div>

          <div style={{ background: '#fff1f0', borderRadius: 8, padding: 16, textAlign: 'left', marginBottom: 24 }}>
            <div style={{ fontSize: 13, color: '#cf1322' }}>
              <strong>⏰ 重要提醒：</strong>
              <ul style={{ margin: '8px 0 0', paddingLeft: 20, lineHeight: 1.8 }}>
                <li>7天体验期结束后，如需继续使用请联系我们续费</li>
                <li>续费可享受优惠价格</li>
              </ul>
            </div>
          </div>

          <button onClick={() => window.history.back()} style={{ padding: '12px 32px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 16 }}>
            完成
          </button>
        </div>
      </div>
    )
  }

  return (
    <div style={{ paddingTop: 80, padding: 40 }}>
      {/* 顶部功能栏 */}
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'12px 16px',background:'#1890ff',color:'#fff',marginBottom:16,borderRadius:8}}>
        <button onClick={()=>window.location.href='/cms/'} style={{padding:'8px 16px',background:'rgba(255,255,255,0.2)',color:'#fff',border:'none',borderRadius:6,cursor:'pointer',fontSize:13}}>← 返回</button>
        <span style={{fontSize:13}}>邀请他人申请</span>
        <button onClick={()=>{var ref=referrerId||new URLSearchParams(window.location.search).get('ref')||'';var l=ref?window.location.origin+'/?page=base-register&ref='+ref:window.location.origin+'/?page=base-register';navigator.clipboard.writeText(l).then(()=>alert('已复制!')).catch(()=>prompt('复制:',l))}} style={{padding:'8px 16px',background:'#fff',color:'#1890ff',border:'none',borderRadius:6,cursor:'pointer',fontWeight:600,fontSize:13}}>复制链接</button>
      </div>

      <div style={{ maxWidth: 600, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <h2 style={{ fontSize: 24, marginBottom: 8 }}>基地注册申请</h2>
          <p style={{ color: '#666' }}>申请成为博小兔活动基地，享受高额分润</p>
        </div>

        {/* 基地类型说明 */}
        <div style={{ background: '#fff7e6', border: '1px solid #ffd591', borderRadius: 8, padding: 16, marginBottom: 24 }}>
          <div style={{ fontWeight: 600, color: '#fa8c16', marginBottom: 8 }}>🏪 基地权益</div>
          <div style={{ fontSize: 13, color: '#666', lineHeight: 1.8 }}>
            • 发布活动可获得 <strong style={{ color: '#fa8c16' }}>60-90%</strong> 服务分润<br/>
            • 享受平台流量扶持<br/>
            • 专业活动策划支持<br/>
            • 学员管理系统支持
          </div>
        </div>

        {step === 1 ? (
          <div style={{ background: '#fff', borderRadius: 16, padding: 24 }}>
            <h3 style={{ marginBottom: 16 }}>基地基本信息</h3>
            
            <div style={{ marginBottom: 16 }}>
              <label style={label}>基地名称 *</label>
              <input type="text" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="请输入基地全称" style={input} />
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={label}>基地类型</label>
              <select value={form.type} onChange={e => setForm({ ...form, type: e.target.value })} style={input}>
                <option value="机构基地">机构基地（幼儿园/培训机构）</option>
                <option value="企业基地">企业基地（公司/单位）</option>
                <option value="独立基地">独立基地（专属活动场地）</option>
              </select>
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={label}>所在城市 *</label>
              <input type="text" value={form.city} onChange={e => setForm({ ...form, city: e.target.value })} placeholder="如：杭州、上海" style={input} />
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={label}>详细地址 *</label>
              <input type="text" value={form.address} onChange={e => setForm({ ...form, address: e.target.value })} placeholder="请输入详细地址" style={input} />
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={label}>联系人 *</label>
              <input type="text" value={form.contact} onChange={e => setForm({ ...form, contact: e.target.value })} placeholder="请输入联系人姓名" style={input} />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label style={label}>联系电话 *</label>
              <input type="tel" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="请输入手机号" maxLength={11} style={input} />
            </div>

            <button onClick={() => setStep(2)} style={{ width: '100%', padding: 14, background: '#1890ff', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 16 }}>
              下一步：场地信息
            </button>
          </div>
        ) : (
          <div style={{ background: '#fff', borderRadius: 16, padding: 24 }}>
            <h3 style={{ marginBottom: 16 }}>场地信息（选填）</h3>
            
            <div style={{ marginBottom: 16 }}>
              <label style={label}>接待容量</label>
              <input type="text" value={form.capacity} onChange={e => setForm({ ...form, capacity: e.target.value })} placeholder="如：可同时接待50组家庭" style={input} />
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={label}>场地设施</label>
              <input type="text" value={form.facilities} onChange={e => setForm({ ...form, facilities: e.target.value })} placeholder="如：多媒体教室、户外活动区" style={input} />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label style={label}>基地简介</label>
              <textarea value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} placeholder="介绍一下您的基地特色和优势" rows={4} style={{ ...input, resize: 'vertical' }} />
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={label}>推荐码（选填）{referrerId && <span style={{color: '#52c41a', marginLeft: 8}}>✓ 已找到推荐人</span>}</label>
              <input type="text" value={form.recommendCode} onChange={e => handleRecommendCodeChange(e.target.value)} placeholder="如有推荐人请填写推荐码" style={input} />
              <div style={{fontSize: 11, color: '#999', marginTop: 4}}>推荐人注册后获得的ID或推荐码</div>
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={label}>登录密码 *</label>
              <input type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} placeholder="请设置登录密码（至少6位）" minLength={6} style={input} />
            </div>

            <div style={{ display: 'flex', gap: 12 }}>
              <button onClick={() => setStep(1)} style={{ flex: 1, padding: 14, background: '#f5f5f5', color: '#666', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 16 }}>
                上一步
              </button>
              <button onClick={handleSubmit} disabled={loading} style={{ flex: 2, padding: 14, background: loading ? '#d9d9d9' : '#52c41a', color: '#fff', border: 'none', borderRadius: 8, cursor: loading ? 'not-allowed' : 'pointer', fontSize: 16 }}>
                {loading ? '提交中...' : '提交申请'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

const label = { display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }
const input = { width: '100%', padding: '12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' }
